import styled, { css } from 'styled-components'
import fbIcon from '@/assets/static-img/facebook.png'
import twitterIcon from '@/assets/static-img/twitter.png'
import { openPage, rpx } from '@/utils'
import { useEffect, useRef, useState } from 'react'
import appExpose from '@app/expose'
import { Handler } from 'mitt'
import { checkPlayer } from '@/request/utils'
import { NativeRequest } from 'onemt-sdk-native'
import { clickReport } from '@app/report'
import { $t } from '@/i18n/LocalContext'

const { config } = appExpose

const Block = styled.ul`
  position: absolute;
  z-index: -1;
  /* z-index: 101; */
  left: 0;
  top: ${rpx(config.scssVariables['$nav-height'])};
  opacity: 0;
  padding: 0 1.5rem 1.5rem;
  box-sizing: border-box;
  border-radius: 1rem;
  background: #292929;
`

const Box = styled.li<{ $type: Window['queryObj']['source'] }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 10rem;
  height: 10rem;
  background-repeat: no-repeat;
  background-position: 0;
  background-size: 100%;
  border-radius: 1rem;
  overflow: hidden;
  margin-top: 1.5rem;
  ${(props) => {
    let icon = 'none'
    switch (props.$type) {
      case 'twitter':
        icon = twitterIcon
        break

      default:
        icon = fbIcon
        break
    }
    return css`
      background-image: url(${icon});
    `
  }};
`

const getShareLink = () => {
  let search = ''
  if (window.location.search) {
    search = `${window.location.search}`
  }
  const host =
    process.env.ENV === 'production'
      ? 'h5share.onemtshare.com'
      : 'testh5share.onemtshare.com'
  return `https://${host}/${config.game}/${config.name}/${search}`
}

const Share = () => {
  // 使用更精确的类型，方便直接传递给 ref 属性
  const shareList = useRef<HTMLUListElement | null>(null)
  const show = useRef(false)
  const shareLink = getShareLink()

  useEffect(() => {
    const gameCont = document.querySelector('#App')

    if (!gameCont || !shareList.current) return

    const _clickHandle = (e: MouseEvent) => {
      let target = e.target as Partial<HTMLElement> | null | undefined
      const value = 'share-list'
      const name = 'share-item'
      let hit = false
      const _ct = () => {
        if (!target || target.className === value) return false

        const parentElement = target.parentElement
        if (
          parentElement &&
          parentElement.classList.contains(value) &&
          target.className &&
          target.classList?.contains(name)
        ) {
          hit = true
          return false
        }
        return true
      }
      while (_ct()) {
        if (target) {
          target = target.parentElement
        }
      }
      if (hit && target && target.dataset) {
        appExpose.emitter.emit('share')
        const dataset: { source?: Window['queryObj']['source'] } =
          target.dataset
        const source = dataset.source
        const imageUrl = `${process.env.BASE_URL2}${config.share.image}`
        const title = $t('庆典活动分享标题')
        const content = $t('庆典活动分享描述') || ''
        const _fbshare = () => {
          clickReport('FBshare')
          const url = `${shareLink}&source=${source}`
          const link = `https://www.facebook.com/sharer.php?u=${encodeURIComponent(
            url
          )}`
          if (window.inSDK) {
            NativeRequest('share', {
              type: 1,
              title,
              url,
              imageUrl,
              content,
            })
          } else {
            openPage(link)
          }
        }
        const _twittershare = () => {
          clickReport('TWshare')
          const via = ''
          const url = `${shareLink}&via=${via}&source=${source}`
          const contentLength = content.length
          const maxLength = 250
          const xContent = `${content.slice(0, maxLength)}${
            contentLength > maxLength ? '...' : ''
          }`
          if (window.inSDK) {
            NativeRequest('share', {
              type: 2,
              title,
              url,
              imageUrl,
              content: xContent,
            })
          } else {
            const text = `${xContent} ${encodeURIComponent(url)}`
            openPage(`https://twitter.com/intent/tweet?text=${text}`)
          }
        }
        const _pinterestshare = () => {
          const url = `https://www.pinterest.com/pin/create/button/?url=${encodeURIComponent(
            `${shareLink}&source=${source}`
          )}`
          openPage(url)
        }
        const _insshare = () => {
          const url = encodeURIComponent(`${shareLink}&source=${source}`)
          NativeRequest('share', {
            type: 7,
            title,
            url,
            imageUrl,
            content,
          })
        }
        switch (source) {
          case 'facebook':
            _fbshare()
            break

          case 'twitter':
            _twittershare()
            break

          case 'ins':
            _insshare()
            break

          default:
            _pinterestshare()
            break
        }
        clickReport('shareA')
      }
    }
    shareList.current.addEventListener('click', _clickHandle)

    const _hideList = () => {
      show.current = false
      if (shareList.current) {
        shareList.current.style.cssText = `z-index: -1; opacity: 0;`
      }
      appExpose.emitter.emit('hideShareList')
    }
    const _showList = async (x: number, y: number) => {
      if (!(await checkPlayer('share'))) return

      if (show.current || !shareList.current) {
        return
      }

      show.current = true
      const gameRect = gameCont.getBoundingClientRect()
      const shareListRect = shareList.current.getBoundingClientRect()
      let _x = x - shareListRect.width / 2
      if (_x < 0) {
        _x = 0
      }
      let _y = y
      if (_y + shareListRect.height > gameRect.height) {
        _y = gameRect.height - shareListRect.height
      }
      shareList.current.style.cssText = `z-index: 101; left: ${_x}px; top: ${_y}px; opacity: 1;`
    }
    const _handler: Handler<MittEvents['showShareList']> = (e) => {
      e.stopPropagation()
      _showList(e.x, e.y)
    }
    appExpose.emitter.on('showShareList', _handler)
    document.body.addEventListener('click', _hideList)

    return () => {
      appExpose.emitter.off('showShareList', _handler)
      document.body.removeEventListener('click', _hideList)
      if (shareList.current) {
        shareList.current.removeEventListener('click', _clickHandle)
      }
    }
  }, [])

  return (
    <Block
      className="share-list"
      ref={(elem: unknown) => {
        shareList.current = elem as HTMLUListElement | null
      }}
    >
      <Box $type="facebook" data-source="facebook" className="share-item"></Box>
      <Box $type="twitter" data-source="twitter" className="share-item"></Box>
    </Block>
  )
}

export default Share
